const ServerUrl = process.env.API_HOST;
const GameUrl =
  "http://cdn10.cdngoto.com/hamini_0621_1640_release/index.html?channel=";
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  console.log(query);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
}

//name 字段名
function getCookie(name) {
  if (document.cookie.length > 0) {
    var start = document.cookie.indexOf(name + "=");
    if (start !== -1) {
      start = start + name.length + 1;
      let end = document.cookie.indexOf(";", start);
      if (end === -1) end = document.cookie.length;
      return unescape(document.cookie.substring(start, end));
    }
  }
  return "";
}
function download() {
  let download_url = ServerUrl + "/api/v1/invite/download-url";
  let inviteCode = getQueryVariable("i");
  download_url = download_url + `?inviteCode=${inviteCode}`;
  var xhr = new XMLHttpRequest();
  xhr.open("GET", download_url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == 200) {
      var data = JSON.parse(xhr.responseText);
      window.location.href = data.data.downloadUrl;
    }
  };
  xhr.send();
  return;
}
async function loadPage() {
  chnup("load");
  return;
}

function chnup(event) {
  // return
  let param = {
    action: event,
    chn: "com.rupeeit.invite",
  };
  let searchStr = window.location.search;
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.open("POST", ServerUrl + `/cthper/behaviors${searchStr}`, true);

  xmlhttp.send(JSON.stringify(param));
}

function goLoginLimit() {
  let msg = localStorage.getItem("clickTime");
  let nowTime = new Date().valueOf();
  console.log(msg, nowTime);
  if (msg == null || msg == "undefine") {
    console.log("===");
    localStorage.setItem("clickTime", nowTime);
    let url = GameUrl;
    window.location.href = url;
    return;
  }
  let clickTime = parseInt(msg);
  if (nowTime - clickTime < 3000) {
    console.log("time < 3s");
    return;
  }
  localStorage.setItem("clickTime", nowTime);
  let url = GameUrl;
  window.location.href = url;
  return;
}

export { loadPage, chnup, download, getQueryVariable, goLoginLimit };



// WEBPACK FOOTER //
// ./src/utils/tools.js